import { Delete, Edit } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import {
  DataGrid,
  DataGridProps,
  GridColDef,
  GridValidRowModel,
} from '@mui/x-data-grid';
import React from 'react';
import { present } from './utilities';

type ICrudDataGridProps<R extends GridValidRowModel = any> = DataGridProps<R> &
  React.RefAttributes<HTMLDivElement> & {
    onClickEdit?: (id: number | string, row: R) => void;
    onClickDelete?: (id: number | string, row: R) => void;
  };

export function buildActionsColumn<R extends GridValidRowModel = any>(
  onClickEdit?: (id: number | string, row: R) => void,
  onClickDelete?: (id: number | string, row: R) => void
): GridColDef<R> | null {
  if (!onClickEdit && !onClickDelete) {
    return null;
  }

  return {
    sortable: false,
    filterable: false,
    field: 'actions',
    type: 'actions',
    headerName: 'Aktionen',
    align: 'right',
    headerAlign: 'right',
    width: 100,
    getActions: params =>
      [
        onClickEdit && (
          <IconButton
            color='primary'
            onClick={() => {
              onClickEdit?.(params.id, params.row);
            }}
          >
            <Edit fontSize='small' />
          </IconButton>
        ),
        onClickDelete && (
          <IconButton
            color='error'
            onClick={() => {
              onClickDelete?.(params.id, params.row);
            }}
          >
            <Delete fontSize='small' />
          </IconButton>
        ),
      ].filter(present),
  };
}

export function CrudDataGrid<R extends GridValidRowModel = any>(
  props: ICrudDataGridProps<R>
) {
  const patchedColumns: GridColDef<R>[] = [
    ...props.columns,
    buildActionsColumn<R>(props.onClickEdit, props.onClickDelete),
  ].filter(present);

  return <DataGrid {...props} columns={patchedColumns} />;
}
